import { Component, Inject, inject } from "@angular/core";
import { AsyncPipe, DOCUMENT } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';

import { LogoutDialogComponent, LogoutDialogResult } from '../logout-dialog/logout-dialog.component';
import { ElofizetoCegService } from '../../../services/elofizeto-ceg.service';

@Component({
    imports: [AsyncPipe, MatButtonModule, MatIconModule],
    selector: 'rendelo-auth',
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.scss',
})
export class AuthComponent {
    private dialog = inject(MatDialog);
    private elofizetoCegService = inject(ElofizetoCegService);

    constructor(
        @Inject(DOCUMENT) public document: Document,
        public authService: AuthService
    ) {}

    openLogoutDialog(): void {
        const dialogRef = this.dialog.open(LogoutDialogComponent, {
            width: '400px'
        });

        dialogRef.afterClosed().subscribe((result: LogoutDialogResult | undefined) => {
            if (result?.confirmed) {
                if (result.clearSelectedCeg) {
                    this.elofizetoCegService.clearSelectedCeg();
                }
                this.authService.logout({ logoutParams: { returnTo: this.document.location.origin } });
            }
        });
    }
}
